<template>
  <el-date-picker
    ref="domDate"
    v-model="value"
    v-bind="$attrs"
    type="dates"
    :name="'c' + formItemMeta.columnId"
    :format="format"
    :value-format="valueFormat"
    :clearable="clearable"
  >
  </el-date-picker>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  // 引入组件需要的属性 引入表单子控件的管理类
  import { itemProps, itemController } from '../map'
  
  /**
   * 年月日
   */
  export default defineComponent({
    name: 'nf-el-from-item-date-more',
    inheritAttrs: false,
    components: {
      // ElDatePicker
    },
    props: {
      ...itemProps, // 基础属性
      format: {
        type: String,
        default: 'YYYY-MM-DD'
      },
      valueFormat: {
        type: String,
        default: 'YYYY-MM-DD'
      },
      colName: String, // 变更字段名称
      modelValue: [Array]
    },
    emits: ['update:modelValue'],
    setup (props, context) {
      const { value } = itemController(props, context.emit)
      
      if (!Array.isArray(value.value)) {
        value.value = []
      }

      return {
        value // 控件值
      }
    }
  })
</script>
